// @flow
import queryString from 'query-string';
import { filterObject } from 'utils/functional';
import { makeSerializedUrlFilters } from 'utils/search/getSearchUrl';

const getPostSearchQueryString = (
  filters: SearchFilters,
  searchFacets: { [string]: SearchFacet },
  query: string,
  currentSearchParams: string
) => {
  const filtersToSerialize = filterObject(
    filters,
    (k, v) =>
      !!v && (!(typeof v === 'string' || v instanceof Array) || v.length > 0)
  );

  const serializedFilters = makeSerializedUrlFilters({
    filters: filtersToSerialize,
    searchFacets
  });

  const utmParams = filterObject(queryString.parse(currentSearchParams), k =>
    k.startsWith('utm')
  );

  const searchParams = {
    pq: query,
    searchMode: true,
    ...utmParams,
    ...serializedFilters
  };

  return queryString.stringify(searchParams);
};

export default getPostSearchQueryString;
